import { Card, Container, Grid, InputBase } from '@mui/material'
import ListaOpcoes from '../../../../utils/listaOpcoes'
import HeaderSession from '../../../../utils/headerSession'
import { useEffect, useState } from 'react'
import api from '../../../../services/api'
import { useSearchParams } from 'react-router-dom'
import Paginacao from '../../../../utils/paginacao'
import LoadingSkeleton from '../../../../load/loadingSkeleton'

export default function InformacoesSite() {
    const [siteInfos, setSiteInfos] = useState([])
    const [configLista, setConfigLista] = useState('')
    const [perPage, setPerPage] = useState(50)
    const [load, setLoad] = useState(false)
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page") ?? 1);
    const [filter, setFilter] = useState('')

    useEffect(() => {
        setSiteInfos([]);
        setLoad(true);
        api.get(`/site-infos?menu=INFORMAÇŌES&perPage=${perPage}&page=${page}`)
            .then(res => {
                // console.log(res)
                setSiteInfos(res.data.siteInfos);
                setConfigLista(res.data);
                setFilter(res.data.siteInfos);
            })
            .catch(() => {
            }).finally(() => {
                setLoad(false);
            });
    }, [page, perPage])


    // FILTRO DE INFORMACOES
    const filtraInformacoes = (valor) => {
        setSiteInfos(filter.filter((informacoes) => (informacoes?.titulo?.toLowerCase().includes(valor.toLowerCase()) || informacoes?.opcao?.toLowerCase().includes(valor.toLowerCase()))))
    }


    return (
        <Container style={{ minHeight: '70vh' }}>

            <HeaderSession title='CENTRAL DE INFORMAÇÕES' />

            <InputBase
                style={{ width: '100%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
                // sx={{ ml: 1, flex: 1 }}
                autoFocus
                placeholder="Filtra aquí as informações"
                inputProps={{ 'aria-label': 'Filtrar lista' }}
                onChange={(e) => { filtraInformacoes(e.target.value) }}
            />

            <Grid container spacing={2} >
                {siteInfos.map((info) => (
                    <Grid key={info._id} item xs={12} sm={6} >
                        <ListaOpcoes
                            url={info?.anexo}
                            nomeOpcao={info?.titulo?.toUpperCase() ?? info?.menu?.toUpperCase()}
                            link={`/informacoes?opcao=${info?.opcao}&menu=${info?.menu}`}
                        />
                    </Grid>
                ))}
                
                {load &&
                    <>
                        <Grid item xs={12} sm={6} >
                            <LoadingSkeleton />
                            <LoadingSkeleton />
                        </Grid>

                        <Grid item xs={12} sm={6} >
                            <LoadingSkeleton />
                            <LoadingSkeleton />
                        </Grid>
                    </>
                }

            </Grid>

            <Card>
                <Paginacao
                    configLista={configLista}
                    lista={siteInfos}
                    page={page}
                    setPage={setPage}
                    setPerPage={setPerPage}
                />
            </Card>

        </Container>
    )
}
